// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__1nsnk","card":"Cards_card__7ZmZe","infected":"Cards_infected__1TtBP","recovered":"Cards_recovered__27te1","deaths":"Cards_deaths__2oKFe"};